import $ from "jquery";

$("#search-toggler").click(function () {
	$(this).toggleClass("search-toggler--opened");
	$(".site-header .search-form__wrapper").toggleClass("search--opened");
});

